<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import { useAnalysisStore } from '@/store/modules/analysis'
import {
  removeAsterisk,
  splitKeywordParts,
  splitBySentence,
  splitSentencesByDivider,
  splitCommaSeparatedWords,
} from '@/composables/splitSentence'
import PersonalPieChart from './PersonalPieChart.vue'
import PersonalityKeyword from './PersonalityKeyword.vue'
import PersonalityIlganBubble from './personalityIlganBubble.vue'

const props = defineProps({
  pData: Object,
  userName: String,
  isMobile: Boolean,
})
const store = useAnalysisStore()
// const userName = computed(() => store.userName)
onMounted(() => {
  // pData.value = store.analysisResult;
})

// 일간 버블
const targetIlgan = computed(() => props.pData.발전방향.풀이대상 ?? '')
const ilganKor = computed(() => {
  return targetIlgan.value.slice(0, 2)
})
const keywords = computed(() => {
  const withoutIlgan = targetIlgan.value.slice(2)
  return withoutIlgan.split('#').filter(Boolean)
})

const dataGathering = computed(() => splitBySentence(props.pData.발전방향.기본특성))
const infoGathering = computed(() => splitBySentence(props.pData.발전방향.상세특성))
const strengthItems = computed(() => splitCommaSeparatedWords(props.pData.발전방향.주요강점))
const weaknessItems = computed(() => splitCommaSeparatedWords(props.pData.발전방향.주요약점))
const strengthDetail = computed(() => splitBySentence(props.pData.발전방향.강점설명))
const weaknessDetail = computed(() => splitBySentence(props.pData.발전방향.약점설명))
const strengthAdvice = computed(() => props.pData.발전방향.강점조언)
const weaknessAdvice = computed(() => props.pData.발전방향.약점조언)
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="detail-card__top-title personality">
          <span class="detail-tit__num personality">9</span>
          <span class="detail-tit__txt personality">나를 발전 시키는 방향은!</span>
        </div>
        <div class="personality-wrapper">
          <div class="person-content-box">
            <div class="personality-chart__wrapper">
              <PersonalityIlganBubble :ilganKor="ilganKor" :keywords="keywords" />
            </div>
          </div>
          <div class="personality-divider" />
          <div class="person-content-box">
            <PersonalityKeyword
              :left-title="['발전 방향을', '말해주는 키워드 😊']"
              :keywords="props.pData.발전방향.주요특징"
              :isMobile="isMobile"
            />
          </div>
          <div class="personality-divider" />

          <div class="person-content-box">
            <div class="content__title">📚 나를 더 나답게 만드는 발전방향</div>
            <div v-for="(sentence, idx) in dataGathering" :key="idx">
              <span class="content__body-txt">
                {{ sentence }}
              </span>
            </div>
          </div>
          <div class="personality-divider" />
          <div class="person-content-box">
            <div class="content__title">🤔 이런 방향도 생각해보세요.</div>
            <div v-for="(sentence, idx) in infoGathering" :key="idx">
              <span class="content__body-txt">
                {{ sentence }}
              </span>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="personality-wrapper">
          <div class="person-desc-box">
            <div class="desc__title">💪 나의 강점을 말해주는 키워드들</div>
            <div class="desc__body blue">
              <div class="top-keyword">
                <div class="top-keyword__box">
                  <div v-for="(item, idx) in strengthItems" :key="idx" class="keyword-item blue">
                    {{ item }}
                  </div>
                </div>
                <div v-for="(str, idx) in strengthDetail" :key="idx" class="top-keyword__desc">
                  {{ str }}
                </div>
              </div>
              <div class="bottom-white-box">
                <div class="white-box__tit">이런 활동도 좋을 수 있어요. 😘</div>
                <div class="white-box__desc">
                  {{ strengthAdvice }}
                </div>
              </div>
            </div>
          </div>
          <div class="person-desc-box">
            <div class="desc__title">👀 이런 부분을 살펴보세요.</div>
            <div class="desc__body red">
              <div class="top-keyword">
                <div class="top-keyword__box">
                  <div v-for="(item, idx) in weaknessItems" :key="idx" class="keyword-item red">
                    {{ item }}
                  </div>
                </div>
                <div v-for="(str, idx) in weaknessDetail" :key="idx" class="top-keyword__desc">
                  {{ str }}
                </div>
              </div>
              <div class="bottom-white-box">
                <div class="white-box__tit">나를 도와주는 생각들 😉</div>
                <div class="white-box__desc">
                  {{ weaknessAdvice }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
